import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[arkModalInsertion]',
})
export class ModalInsertionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
